/**
 * cotizacion-dolar.ts — the US dollar "divisa" rate published by Banco Nación, offered as the default tipo de cambio
 * when paying a foreign invoice. Always a SUGGESTION the tesorero can edit; `cotizacion: null` when the bank's page
 * could not be read (the field is then typed by hand).
 *
 *   GET /sumi/cuentas-pagar/cotizacion-dolar   -> CotizacionDolarResponse
 */
import { z } from 'zod';
import { IsoDateSchema } from './vocab.js';

export const CotizacionDolarSchema = z.object({
  /** The date the bank published the rate for (`YYYY-MM-DD`). */
  fecha: IsoDateSchema,
  /** ARS per USD, decimal strings. */
  compra: z.string(),
  venta: z.string(),
  fuente: z.literal('bna_divisa'),
});
export type CotizacionDolar = z.infer<typeof CotizacionDolarSchema>;

export const CotizacionDolarResponseSchema = z.object({ cotizacion: CotizacionDolarSchema.nullable() });
export type CotizacionDolarResponse = z.infer<typeof CotizacionDolarResponseSchema>;
